import { Button, Col, Divider, Row, Text, useFormatPrice } from 'ui';
import { useGiveNow } from '../../../context';

type P = {
  buttonHtmlType: 'button' | 'submit';
  isLoading?: boolean;
  nextButtonText: string;
  onBack?: () => void;
  onNext?: () => void;
};

const Footer = ({ buttonHtmlType, isLoading, nextButtonText, onBack, onNext }: P) => {
  const formatPrice = useFormatPrice();
  const { viewerItems } = useGiveNow();

  const totalSum = viewerItems.reduce((accumulator, donations) => accumulator + donations.amount, 0);

  return (
    <div className="give-now-footer">
      <Divider className="give-now-footer__divider" />
      <Row align="middle" justify="space-between">
        <Col>
          <Text>Total amount</Text>: <Text weight="bold">{formatPrice({ value: totalSum })}</Text>
        </Col>
        <Col>
          {onBack ? (
            <Button className="give-now-footer__button" onClick={onBack} size="large">
              Back
            </Button>
          ) : null}
          <Button htmlType={buttonHtmlType} loading={isLoading} onClick={onNext} size="large" type="primary">
            {nextButtonText}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
